import React from 'react';
import MainContainer from "Components/mainContainer";
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// https://reactrouter.com/6.29.0/upgrading/v6-data
const router = createBrowserRouter([
    { path: "*", element: <MainContainer /> },
]);

//https://react.dev/blog/2022/03/08/react-18-upgrade-guide#updates-to-client-rendering-apis
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<RouterProvider router={router} />);

// Глобальное объявление свойств, чтобы автодополнение (и анализатор) знало об их существовании.
/** @type {string} */
globalThis.SmrVersion = window.SmrVersion;
/** @type {string} */
globalThis.SmrLocation = window.SmrLocation;